import React from 'react';
import { Plus, X } from 'lucide-react';
import styles from './NumberListEditor.module.css';

interface NumberListEditorProps {
  values: number[];
  onChange: (next: number[]) => void;
  /// Whole numbers only (used for signal window params).
  integer?: boolean;
  step?: number;
  addLabel?: string;
}

/// Editable horizontal list of numbers with per-item remove and an add button.
export const NumberListEditor: React.FC<NumberListEditorProps> = ({
  values,
  onChange,
  integer = false,
  step = 0.1,
  addLabel = 'Add',
}) => {
  const setAt = (idx: number, raw: string) => {
    const parsed = integer ? parseInt(raw, 10) : parseFloat(raw);
    const next = [...values];
    next[idx] = Number.isNaN(parsed) ? 0 : parsed;
    onChange(next);
  };
  const removeAt = (idx: number) => onChange(values.filter((_, i) => i !== idx));
  const add = () => onChange([...values, 0]);

  return (
    <div className={styles.wrap}>
      {values.map((v, idx) => (
        <div key={idx} className={styles.item}>
          <input
            className={styles.input}
            type="number"
            step={integer ? 1 : step}
            value={Number.isFinite(v) ? v : 0}
            onChange={(e) => setAt(idx, e.target.value)}
          />
          <button
            type="button"
            className={styles.remove}
            onClick={() => removeAt(idx)}
            aria-label="Remove value"
          >
            <X size={13} />
          </button>
        </div>
      ))}
      <button type="button" className={styles.add} onClick={add}>
        <Plus size={13} /> {addLabel}
      </button>
    </div>
  );
};
